import {Component, input, ChangeDetectionStrategy} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {KeyValuePipe} from '@angular/common';

@Component({
    selector: 'app-form-group-errors',
    imports: [
        KeyValuePipe
    ],
    templateUrl: './form-group-errors.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './form-group-errors.component.scss'
})
export class FormGroupErrorsComponent {
  inputForm = input.required<FormGroup>();

  getErrorMessage(errorKey: string, errorValue: any): string {
    switch (errorKey) {
      case 'atLeastOneInput':
        return 'You must provide changes to at least one input';
    }
  }
}
